import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '@entities/auth';
import { cardReducer } from '@entities/card';
import { notifyReducer } from '@entities/notify';
import { clientReducer } from '@entities/client';
import { rKeeperReducer } from '@entities/rKeeper';
import { bookingReducer } from '@entities/booking';
import { logsReducer } from '@entities/logs';
import { reportsReducer } from '@entities/reports';
import { appReducer } from '@entities/app';

export const rootReducer = combineReducers({
    auth: authReducer,
    card: cardReducer,
    notify: notifyReducer,
    client: clientReducer,
    rKeeper: rKeeperReducer,
    booking: bookingReducer,
    logs: logsReducer,
    reports: reportsReducer,
    app: appReducer,
});
